export default "__VITE_ASSET__e4ff594e__"